import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export const Ribbon = () => {
  const { t } = useLang();
  return (
    <section className="border-y border-[#E2E0D8] bg-[#0D2A27] py-6 overflow-hidden" data-testid="marquee">
      <Marquee speed={38} gradient={false} autoFill>
        {t.ribbon.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-serif italic text-3xl md:text-4xl text-[#F7F6F2]">{w}</span>
            <span className="text-[#C4A484] text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
